import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { FrequentlyAskedQuestionsListComponent } from './faq-list/faq-list.component';
import { FrequentlyAskedQuestionsDetailComponent } from './faq-detail/faq-detail.component';
import { CanFAQDeactivateGuard } from 'src/app/core/guards/faq-manager.guard';

const routes: Routes = [
  {
    path: 'faq-manager',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: FrequentlyAskedQuestionsListComponent, canDeactivate: [CanFAQDeactivateGuard] },
      { path: 'new', component: FrequentlyAskedQuestionsDetailComponent, canDeactivate: [UnloadGuard] },
      {
        path: ':frequentlyAskedQuestionId',
        component: FrequentlyAskedQuestionsDetailComponent,
        canDeactivate: [UnloadGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class FrequentlyAskedQuestionsRoutingModule {}
